// Base service name
export const SERVICE_NAME = "COOKIE_SERVICE";

export const COOKIE_KEY = {
    ACCESS_TOKEN: "access_token",
};
